import { useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StatsContener, STATS_LAYOUTS, StatsLayout } from '../../../components/stats/StatsContener';
import { StatsValue } from '../../../components/stats/StatsDetailRow';
import { LocationContext } from '../../../contexts/LocationContext';
import { AccessibilityContext } from '../../../contexts/AccessibilityContext';
import { getLocationStatistics } from '../../../helpers/locationStatistics';
import '../../../components/stats/Statistics.css';

export const StatisticsSection = () => {
    const { locations, locationsStatus, reloadLocations } = useContext(LocationContext);
    const { isContrast, sizeText } = useContext(AccessibilityContext);
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const requestedLayout = params.get('statsLayout') as StatsLayout;
    const layout = STATS_LAYOUTS.includes(requestedLayout) ? requestedLayout : 'rows';
    const statistics = useMemo(() => getLocationStatistics(locations), [locations]);

    return <section className={`totupoint-statistics${isContrast ? ' totupoint-statistics--contrast' : ''}`}
        style={{ fontSize: `${16 + sizeText}px` }} id="gdziejestesmy" aria-labelledby="statistics-heading">
        <header className="stats-heading"><h2 id="statistics-heading">TOTUPOINT {t('w liczbach')}</h2></header>
        {locationsStatus === 'loading' ? <p role="status" className="stats-status"><span className="stats-spinner" aria-hidden="true" />{t('stats.loading')}</p>
            : locationsStatus === 'error' ? <div className="stats-status"><p role="status">{t('stats.error')}</p><button type="button" onClick={reloadLocations}>{t('Spróbuj ponownie')}</button></div>
                : <>
                    <dl className="stats-totals">
                        {(['points', 'objects', 'cities'] as const).map(metric => <div key={metric} className={`stats-total-${metric}`}>
                            <dt>{t(`stats.${metric}`)}</dt><dd><StatsValue value={statistics.totals[metric]} /></dd>
                        </div>)}
                    </dl>
                    {statistics.totals.points === 0 ? <p className="stats-status">{t('stats.empty')}</p> :
                        <StatsContener groups={statistics.groups} layout={layout} />
                    }
                </>}
    </section>;
};
